import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { LocationSettingsDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import MoveEmployeeModal from 'modules/locations/components/MoveEmployee'

const MoveEmployeeModalPage = () => {
  const { navigation } = useNavigation()
  const { id, employeeId } = useStrictParams<'id' | 'employeeId'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.locations.locationsId.employees.fullPath({ id }))
  }

  const { data, loading } = useQuery(LocationSettingsDocument)
  if (loading) return <Loading />

  return (
    <AuthorizeUser authorizeFn={() => !!data?.locations._policies.locationManage.can}>
      <MoveEmployeeModal locationId={+id} employeeId={+employeeId} onClose={onClose} />
    </AuthorizeUser>
  )
}

export default MoveEmployeeModalPage
